import React from 'react';
import ScriptTag from 'react-script-tag';

const GoogleAdSense = () => (
  <ScriptTag
    isHydrating
    async
    src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-5154451786614564"
    crossOrigin="anonymous"
  />
);

export default GoogleAdSense;
